export default "__VITE_ASSET__fa1b03ca__"